import styled, { keyframes } from 'styled-components';
import { forSmallDevices, forExtraSmallDevices } from '@pole-journal-web/app-theme';

export const Root = styled.div`
    display: flex;
    flex-direction: row;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    align-items: center;
    justify-content: center;
`;

const pulsingAnimation = keyframes`
    to { transform:scale(1.8); opacity:0; }
`;

export const Loader = styled.div`
    display: inline-grid;
    font-size: 60px;
    ${forSmallDevices('font-size: 50px;')}
    ${forExtraSmallDevices('font-size: 40px;')}

    &:before,
    &:after {
        content: "Acrobacy";
        grid-area: 1/1;
        color: #039be5;
        font-family: sans-serif;
    }

    &:after {
        animation-name: ${pulsingAnimation};
        animation-duration: 1s;
        animation-iteration-count: infinite;
    }
`;
